import { c as _c } from "react/compiler-runtime";
import { EyeIcon, EyeOffIcon } from "lucide-react";
import { type InputHTMLAttributes, useState } from "react";
import { cn } from "@/lib/utils";
import { Input } from "@/modules/users/components/form-items";
interface PasswordInputProps extends InputHTMLAttributes<HTMLInputElement> {
  error?: string;
}
export function PasswordInput(t0) {
  const $ = _c(31);
  let className;
  let error;
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      error,
      className,
      placeholder: t1,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = error;
    $[3] = props;
    $[4] = t1;
  } else {
    className = $[1];
    error = $[2];
    props = $[3];
    t1 = $[4];
  }
  const placeholder = t1 === undefined ? "\u8F93\u5165\u60A8\u7684\u5BC6\u7801" : t1;
  const [showPassword, setShowPassword] = useState(false);
  let t2;
  if ($[5] !== showPassword) {
    t2 = () => {
      setShowPassword(!showPassword);
    };
    $[5] = showPassword;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const togglePasswordVisibility = t2;
  const t3 = showPassword ? "text" : "password";
  let t4;
  if ($[7] !== className) {
    t4 = cn("pr-10 !text-xs md:!text-base placeholder:!text-xs md:placeholder:!text-base", className);
    $[7] = className;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== placeholder || $[10] !== props || $[11] !== t3 || $[12] !== t4) {
    t5 = <Input type={t3} autoComplete="new-password" autoCorrect="off" autoCapitalize="off" spellCheck="false" data-form-type="other" placeholder={placeholder} className={t4} {...props} />;
    $[9] = placeholder;
    $[10] = props;
    $[11] = t3;
    $[12] = t4;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  const t6 = props.disabled || props.value === "" ? "opacity-50" : "opacity-80";
  let t7;
  if ($[14] !== t6) {
    t7 = cn("absolute right-1 top-1/2 -translate-y-1/2 h-8 w-8", t6);
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  const t8 = props.disabled || props.value === "";
  let t9;
  if ($[16] !== showPassword) {
    t9 = !showPassword ? <EyeOffIcon className="h-4 w-4" /> : <EyeIcon className="h-4 w-4" />;
    $[16] = showPassword;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== t7 || $[19] !== t8 || $[20] !== t9 || $[21] !== togglePasswordVisibility) {
    t10 = <button type="button" className={t7} onClick={togglePasswordVisibility} tabIndex={-1} disabled={t8}>{t9}</button>;
    $[18] = t7;
    $[19] = t8;
    $[20] = t9;
    $[21] = togglePasswordVisibility;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  let t11;
  if ($[23] !== t10 || $[24] !== t5) {
    t11 = <div className="relative">{t5}{t10}</div>;
    $[23] = t10;
    $[24] = t5;
    $[25] = t11;
  } else {
    t11 = $[25];
  }
  let t12;
  if ($[26] !== error) {
    t12 = error && <p className="text-sm text-destructive leading-[1.5]">{error}</p>;
    $[26] = error;
    $[27] = t12;
  } else {
    t12 = $[27];
  }
  let t13;
  if ($[28] !== t11 || $[29] !== t12) {
    t13 = <div className="space-y-2">{t11}{t12}</div>;
    $[28] = t11;
    $[29] = t12;
    $[30] = t13;
  } else {
    t13 = $[30];
  }
  return t13;
}